// extracted by mini-css-extract-plugin
export default {"colored":"Button_colored__R2qYr","offColored":"Button_offColored__spzh8"};